import { Clause_1Y_T1, Clause_2Y_3Y_T2, Clause_36M_T1 } from 'mobileApp/store'

export type PaymentType = 'M' | '1Y' | '2Y' | '3Y'

type ClauseConfig = {
  id: string
  title: string
  content: React.ComponentType | (() => JSX.Element)
}

export const PAYMENT_CLAUSE_MAP: Record<PaymentType, ClauseConfig> = {
  M: {
    id: 'Clause_36M_T1',
    title: '安達產物行動裝置保險（分期交付型）(T1)',
    content: Clause_36M_T1,
  },
  '1Y': {
    id: 'Clause_1Y_T1',
    title: '安達產物行動裝置保險（一次交付型）(T1)',
    content: Clause_1Y_T1,
  },
  '2Y': {
    id: 'Clause_2Y_3Y_T2',
    title: '安達產物行動裝置保險（一次交付型）(T2)',
    content: Clause_2Y_3Y_T2,
  },
  '3Y': {
    id: 'Clause_2Y_3Y_T2',
    title: '安達產物行動裝置保險（一次交付型）(T2)',
    content: Clause_2Y_3Y_T2,
  },
}
